"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Account = void 0;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uiKit = require("@cian/ui-kit");
var styles = _interopRequireWildcard(require("./Account.css"));
var _Button = require("../Button");
var _prepareAccountInfo = require("../../utils/prepareAccountInfo");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Account = _ref => {
  let {
    loading,
    disabled,
    email,
    phone,
    avatarUrl,
    agencyName,
    lastActivityDate,
    publishedAnnouncementsCount,
    onClick
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  const handleClick = React.useCallback(() => onClick(), [onClick]);
  return /*#__PURE__*/React.createElement(_Button.Button, {
    disabled: loading || disabled,
    loading: loading,
    deviceType: deviceType,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['account-icon'],
    "data-name": "avatar"
  }, !disabled && avatarUrl ? /*#__PURE__*/React.createElement("img", {
    className: styles['avatar'],
    decoding: "async",
    loading: "lazy",
    src: avatarUrl
  }) : /*#__PURE__*/React.createElement(_uiKit.IconUser16, null)), /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames.default)(styles['account-content'], styles[`account-content--${deviceType}`])
  }, email && /*#__PURE__*/React.createElement("span", {
    className: styles['account-content--email']
  }, /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph1, {
    color: disabled ? 'black_60' : 'black_100',
    "data-name": "email"
  }, email)), phone && /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph1, {
    color: disabled ? 'black_60' : 'black_100',
    "data-name": "phone"
  }, phone), agencyName && /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph2, {
    color: "black_60",
    "data-name": "agencyName"
  }, agencyName), (publishedAnnouncementsCount || lastActivityDate) && /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph2, {
    color: "black_60",
    "data-name": "AccountInfo"
  }, (0, _prepareAccountInfo.prepareAccountInfo)({
    publishedAnnouncementsCount,
    lastActivityDate
  }))), !disabled && /*#__PURE__*/React.createElement("span", {
    "data-name": "ChevronBtn",
    className: styles['chevron-button']
  }, /*#__PURE__*/React.createElement(_uiKit.IconButton, {
    icon: /*#__PURE__*/React.createElement(_uiKit.IconChevronRight16, {
      color: "primary_100"
    })
  })));
};
exports.Account = Account;
Account.displayName = 'Account';